module.exports = __webpack_public_path__ + "static/media/SurveyScreen.23cce9ac.png";